export var NavDirection;

(function (NavDirection) {
  NavDirection[NavDirection["PREV"] = -1] = "PREV";
  NavDirection[NavDirection["NEXT"] = 1] = "NEXT";
})(NavDirection || (NavDirection = {}));